<template>
    <card
        :label-top-left="$t('msg.accounts')"
        icon="mdi-currency-usd"
        class="card_max-xs"
    >
        <template v-slot:bottom>
            <filters
                    v-model="filters"
                    :bool-singles="['is_archive']"
                    name="accounts"
                    @clear="clearFilters"
            >
                <v-switch
                        v-model="filters.is_archive"
                        :label="$t('msg.inArchive')"
                        dense
                        hide-details
                ></v-switch>
            </filters>
        </template>
        <template
                slot="header"
        >
            <v-btn
                    small
                    color="primary"
                    :to="{name: 'create_account'}"
                    :fab="$vuetify.breakpoint.smAndDown"
                    elevation="0"
            >
                <v-icon
                        :class="{'mr-1': !$vuetify.breakpoint.smAndDown}"
                >mdi-plus</v-icon>
                <template v-if="!$vuetify.breakpoint.smAndDown">{{ $t('msg.toCreate') }}</template>
            </v-btn>
        </template>
        <v-data-table
                v-if="!$vuetify.breakpoint.smAndDown"
                :headers="headers"
                :items="filteredModels"
                :loading="loading"
                hide-default-footer
                :items-per-page="3000"
                class="v-data-table_small"
                sort-by="name"
                :mobile-breakpoint="0"
        >
            <template v-slot:item.name="{item}">
                <router-link
                        :to="{name: 'edit_account', params: {id: item.id}}"
                        style="color: rgb(51, 51, 51); display: block;"
                >{{ item.name }}</router-link>
            </template>
            <template v-slot:item.balance="{item}">
                {{ item.balance | numFormat('0,0.00') }} {{ findItem(currencies, item.currency_id, 'symbol') }}
            </template>
            <template v-slot:item.actions="{item}">
                <actions
                        edit="edit_account"
                        :id="item.id"
                ></actions>
            </template>
            <template v-slot:body.append>
                <tr>
                    <td></td>
                    <td style="padding: 5px 10px;">
                        <div class="d-flex align-end flex-column">
                            <div v-for="(item, currencyId) in sum" style="font-weight: 500; font-size: 12px;">
                                {{ item | numFormat('0,0.00') }} {{ findItem(currencies, parseInt(currencyId), 'symbol') }}
                            </div>
                        </div>
                    </td>
                    <td></td>
                </tr>
            </template>
        </v-data-table>
        <v-progress-linear
                v-if="loading"
                indeterminate
        ></v-progress-linear>
        <div v-if="$vuetify.breakpoint.smAndDown && !loading" class="mobile-table">
            <div
                    v-for="(item, key) in filteredModels"
                    :key="key"
                    class="mobile-table__item"
                    @click="$router.push({name: 'edit_account', params: {id: item.id}})"
            >
                <div class="mobile-table__left">
                    <div class="mobile-table__row">{{ item.name }}</div>
                </div>
                <div class="mobile-table__right">
                    <div class="mobile-table__row mobile-table__row_big">
                        {{ item.balance | numFormat('0,0.00') }} {{ findItem(currencies, item.currency_id, 'symbol') }}
                    </div>
                </div>
            </div>
        </div>
    </card>
</template>

<script>
    import Actions from '@/components/ui/Actions';
    import Filters from '../../../components/ui/Filters';

    export default {
        components: {Actions, Filters},
        data() {
            return {
                loading: false,
                models: [],
                currencies: [],
                filters: {
                    is_archive: false
                }
            }
        },
        computed: {
            headers() {
                let items = [
                    {text: this.$t('msg.name'), value: 'name', align: 'start', sortable: true, show: true},
                    {text: this.$t('msg.balance'), value: 'balance', align: 'end', sortable: true, show: true},
                    {text: this.$t('msg.actions'), value: 'actions', align: 'center', sortable: false, width: 100, show: !this.$vuetify.breakpoint.xsOnly}
                ];

                return items.filter(v => v.show);
            },
            filteredModels: {
                get: function() {
                    return this.models.filter(model => {

                        let isArchive = () => {
                            return model.is_archive === this.filters.is_archive;
                        };

                        return isArchive();
                    });
                },
                set: function(v) {
                    this.models = v
                }
            },
            sum() {
                let mapCurrency = {};
                this.filteredModels.forEach(item => {
                    if (mapCurrency[item.currency_id]) {
                        mapCurrency[item.currency_id] += item.balance;
                    } else {
                        mapCurrency[item.currency_id] = item.balance;
                    }
                });
                return mapCurrency;
            }
        },
        methods: {
            clearFilters() {
                this.filters.is_archive = false;
            },
            loadModels() {
                this.loading = true;
                this.$store.dispatch('loadAccounts', {params: this.req})
                    .then(res => this.models = res)
                    .finally(() => this.loading = false);
            },
            loadCurrencies() {
                this.$store.dispatch('loadCurrencies')
                    .then(res => this.currencies = res);
            }
        },
        created() {
            this.loadModels();
            this.loadCurrencies();
        }
    }
</script>
